import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import {
  containerStyle,
  buttonRecipe,
  iconStyle,
} from './togglableButtons.css';
import clsx from 'clsx';
import { Typography } from '../typography/typography';

interface TogglableButton {
  value: string;
  label: string;
}

interface TogglableButtonsProps {
  options: TogglableButton[];
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
  disabled?: boolean;
}

export const TogglableButtons: React.FC<TogglableButtonsProps> = ({
  options,
  value = [],
  onChange,
  className,
  disabled = false,
}) => {
  const handleToggle = (buttonValue: string) => {
    if (disabled) return;

    const isSelected = value.includes(buttonValue);
    const newValue = isSelected
      ? value.filter((v) => v !== buttonValue)
      : [...value, buttonValue];

    onChange(newValue);
  };

  return (
    <div className={clsx(containerStyle, className)}>
      {options.map((option) => {
        const isToggled = value.includes(option.value);

        return (
          <button
            key={option.value}
            type="button"
            className={buttonRecipe({ toggled: isToggled })}
            onClick={() => handleToggle(option.value)}
            disabled={disabled}
            aria-pressed={isToggled}
          >
            <span className={iconStyle}>
              <FontAwesomeIcon icon={isToggled ? faEye : faEyeSlash} />
            </span>
            <Typography as="span" variant="body" size="large">
              {option.label}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};
